import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';
import { useSMLCountryParam } from './useSMLCountryParam';

interface UseArtistPlaylistAdditionsProps {
  artistId: string;
  date?: Date;
}

export const useArtistPlaylistAdditions = ({ artistId, date }: UseArtistPlaylistAdditionsProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  const { countryCode } = useSMLCountryParam();

  const playlistAdditionsQuery = useTRPCQuery(
    trpcMusicAPI.artists.playlistAdditions.queryOptions({
      artistId,
      date,
      // Public share links pin the global view.
      countryCode: shareTokenInput.shareToken !== undefined ? undefined : countryCode,
      ...shareTokenInput,
    })
  );

  return playlistAdditionsQuery;
};
